import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { SubCompany } from '../../types/company';

export interface SubCompanySelectProps {
  subCompanies: SubCompany[];
  selectedSubCompanyId: number | null;
  loadingOrgData: boolean;
  validationError?: string;
  hintText?: string;
  onChange: (subCompanyId: number, code: string) => void;
}

const SubCompanySelect: React.FC<SubCompanySelectProps> = ({
  subCompanies,
  selectedSubCompanyId,
  loadingOrgData,
  validationError,
  hintText,
  onChange,
}) => (
  <FormControl fullWidth required error={!!validationError}>
    <InputLabel>Sub-Company</InputLabel>
    <Select
      value={selectedSubCompanyId || ''}
      onChange={(e) => {
        const subCompanyId = e.target.value as number;
        const sc = subCompanies.find((s) => s.id === subCompanyId);
        onChange(subCompanyId, sc?.code || sc?.name || '');
      }}
      label="Sub-Company"
      disabled={loadingOrgData || subCompanies.length === 0}
    >
      {subCompanies.length === 0 && (
        <MenuItem value="" disabled>
          No sub-companies available
        </MenuItem>
      )}
      {subCompanies.map((sc) => (
        <MenuItem key={sc.id} value={sc.id}>
          {sc.name} {sc.code ? `(${sc.code})` : ''}
        </MenuItem>
      ))}
    </Select>
    {validationError && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
        {validationError}
      </Typography>
    )}
    {!validationError && hintText && (
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5 }}>
        {hintText}
      </Typography>
    )}
  </FormControl>
);

export default SubCompanySelect;
